import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export var useDisplayEffects = function useDisplayEffects(open) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      display = _useState2[0],
      setDisplay = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      effectToggle = _useState4[0],
      setEffectToggle = _useState4[1];

  useEffect(function () {
    if (!display && open) {
      setDisplay(true);
      setTimeout(function () {
        return setEffectToggle(true);
      }, 50);
    }

    if (display && !open) {
      setEffectToggle(false);
      setTimeout(function () {
        return setDisplay(false);
      }, 100);
    }
  }, [open]);
  return {
    display: display,
    effectToggle: effectToggle
  };
};